import { toast } from 'react-toastify';
import styled from 'styled-components';

interface RescueIntroProps {
  onClick?: () => void;
}

const IntroRescue = ({ onClick }: RescueIntroProps) => {
  const toastMessage = (message: string) => <div style={{ fontSize: '1.1rem' }}>{message}</div>;

  const onClickDisAgree = async () => {
    toast(toastMessage('등원불가 처리하였습니다.'), { type: 'success' });
  };

  return (
    <IntroRescueTemplate>
      <BottomImageWrap>
        <img style={{ width: '75px' }} src={process.env.PUBLIC_URL + '/images/img_intro.svg'} alt="intro" />
      </BottomImageWrap>
      <BottomIntroText>
        수색구조 현장에 참여 가능하신 대원은
        <br />
        수락하기 버튼을 클릭해주시기 바랍니다.
      </BottomIntroText>
      <ButtonWrap>
        <BottomDisAgreeButton onClick={onClickDisAgree}>{'동원불가'}</BottomDisAgreeButton>
        <BottomAgreeButton onClick={onClick}>{'수락하기'}</BottomAgreeButton>
      </ButtonWrap>
    </IntroRescueTemplate>
  );
};

const IntroRescueTemplate = styled.div`
  position: absolute;
  width: 100%;
  bottom: 0;
  align-items: center;
  text-align: center;
  white-space: pre-line;
  background: #000d3a;
`;
const BottomImageWrap = styled.div`
  margin-top: 15px;
  align-items: center;
  text-align: center;
  margin-bottom: 10px;
`;
const BottomIntroText = styled.h1`
  width: 100%;
  height: 50px;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  align-items: center;
  text-align: center;
  color: #ffffff;
`;
const ButtonWrap = styled.div`
  width: 100%;
  padding: 20px;
  display: flex;
  justify-content: center;
  > * {
    &:not(:last-child) {
      margin-right: 10px;
    }
  }
`;
const BottomAgreeButton = styled.button`
  width: 214px;
  height: 46px;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 20px;
  align-items: center;
  text-align: center;
  color: #ffffff;
  background: #0086ff;
  cursor: pointer;
  border-radius: 5px;
`;
const BottomDisAgreeButton = styled(BottomAgreeButton)`
  color: #001b61;
  background: #ffffff;
`;

export default IntroRescue;
